function init(){

    $('#contact-form').on('submit',function(e){
        e.preventDefault();

        $.post(
            "/api/contact/submit/",
            $(this).serialize(),
            function() {

                let envelope = $('.envelope');
                let successMessage = $('#success-message');

                // Start the envelope transitioning
                envelope.addClass('transition_up');
                $('.contact_form').removeClass('open_form');
                envelope.addClass('fadeOutRight');

                // Start the top flap animation
                $('.top_flap').delay(450).queue(function(){$(this).addClass('close_sesame').dequeue();});

                // Show the success message and hide the envelope
                successMessage.delay(1200).queue(function(){$(this).toggleClass('u-hidden').dequeue();});
                envelope.delay(1200).queue(function(){$(this).toggleClass('u-hidden').dequeue();});

                // Transition container
                $('#email-banner__container').delay(1200).queue(function(){$(this).toggleClass('email-banner__container--transition').dequeue();});
                successMessage.delay(200).queue(function(){$(this).toggleClass('success-message--sent').dequeue();});
            }
        );
    });
}

export default { init }